module.exports = __webpack_public_path__ + "static/media/kokhet.f54c5e95.mp3";